module.exports = __webpack_public_path__ + "img/01_Certificaciones_ISO_2015.c06355eb.jpg";